export var TABLE_CELL_CLASS_PREFIX = 'TableCell';
export var tableCellRootTestId = 'TableCellRoot';